// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./xterm.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./notyf.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!./fonts.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/noise.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::after,
*::before {
    box-sizing: border-box;
}

html {
    height: 100%;
}

body {
    position: relative;
    overflow: hidden;
    min-height: 100vh;
    width: 100%;
    margin: 0;
    padding: 60px 55px;
    background: #35210d;
}

.grain-filter {
    position: absolute;
    inset: -200%;

    pointer-events: none;

    opacity: 30%;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    animation: shift 0.7s linear infinite both;
}

.box-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 103;

    pointer-events: none;

    box-shadow: inset 0px 0px 200px -2px rgba(0, 0, 0, 1);
}

@keyframes shift {
    0% {
        transform: translateX(10%) translateY(10%);
    }
    100% {
        transform: translateX(-10%) translateY(-10%);
    }
}

.scanlines {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.scanlines:before,
.scanlines:after {
    display: block;
    pointer-events: none;
    content: '';
    position: absolute;
}

.scanlines:before {
    width: 100%;
    height: 2px;
    z-index: 101;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(255, 255, 255, 0.2) 10%,
        rgba(0, 0, 0, 0.1) 100%
    );
    opacity: 0.75;
    animation: scanline 10s linear infinite;
}

.scanlines:after {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 102;
    background: linear-gradient(
        to bottom,
        transparent 50%,
        rgba(0, 0, 0, 0.3) 51%
    );
    background-size: 100% 4px;
    animation: scanlines 1s steps(60) infinite;
}

@keyframes scanline {
    0% {
        transform: translate3d(0, 200000%, 0);
    }
}
@keyframes scanlines {
    0% {
        background-position: 0 50%;
    }
}

@keyframes scan {
    0% {
        background-position: 0 100%;
    }
    100% {
        background-position: 0 -100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAIA;;;IAGI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;;IAEZ,oBAAoB;;IAEpB,YAAY;IACZ,mDAAsC;IACtC,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;;IAEZ,oBAAoB;;IAEpB,qDAAqD;AACzD;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;;IAEI,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ;;;;;KAKC;IACD,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,YAAY;IACZ;;;;KAIC;IACD,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":["@import url('xterm.css');\n@import url('notyf.css');\n@import url('fonts.css');\n\n*,\n*::after,\n*::before {\n    box-sizing: border-box;\n}\n\nhtml {\n    height: 100%;\n}\n\nbody {\n    position: relative;\n    overflow: hidden;\n    min-height: 100vh;\n    width: 100%;\n    margin: 0;\n    padding: 60px 55px;\n    background: #35210d;\n}\n\n.grain-filter {\n    position: absolute;\n    inset: -200%;\n\n    pointer-events: none;\n\n    opacity: 30%;\n    background: url('../assets/noise.png');\n    animation: shift 0.7s linear infinite both;\n}\n\n.box-shadow {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 103;\n\n    pointer-events: none;\n\n    box-shadow: inset 0px 0px 200px -2px rgba(0, 0, 0, 1);\n}\n\n@keyframes shift {\n    0% {\n        transform: translateX(10%) translateY(10%);\n    }\n    100% {\n        transform: translateX(-10%) translateY(-10%);\n    }\n}\n\n.scanlines {\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n}\n\n.scanlines:before,\n.scanlines:after {\n    display: block;\n    pointer-events: none;\n    content: '';\n    position: absolute;\n}\n\n.scanlines:before {\n    width: 100%;\n    height: 2px;\n    z-index: 101;\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0) 0%,\n        rgba(255, 255, 255, 0.2) 10%,\n        rgba(0, 0, 0, 0.1) 100%\n    );\n    opacity: 0.75;\n    animation: scanline 10s linear infinite;\n}\n\n.scanlines:after {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 102;\n    background: linear-gradient(\n        to bottom,\n        transparent 50%,\n        rgba(0, 0, 0, 0.3) 51%\n    );\n    background-size: 100% 4px;\n    animation: scanlines 1s steps(60) infinite;\n}\n\n@keyframes scanline {\n    0% {\n        transform: translate3d(0, 200000%, 0);\n    }\n}\n@keyframes scanlines {\n    0% {\n        background-position: 0 50%;\n    }\n}\n\n@keyframes scan {\n    0% {\n        background-position: 0 100%;\n    }\n    100% {\n        background-position: 0 -100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
